/* src/app/shared/controls/pageable-table/pageable-table.component.scss */
.invisible {
  color: transparent;
}
table {
  font-size: 12pt;
  justify-content: left;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
}
@media (max-width: 2560px) {
  table {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  table {
    font-size: 12pt;
  }
}
@media (max-width: 1280px) {
  table {
    font-size: 10pt;
  }
}
@media (max-width: 1024px) {
  table {
    font-size: 8pt;
  }
}
thead {
  background-color: #1b638b;
  font-weight: 300;
  font-size: 12pt;
  height: 40px;
  color: #fff;
  font-family: "Marsh Serif", serif;
}
@media (max-width: 2560px) {
  thead {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  thead {
    font-size: 12pt;
  }
}
@media (max-width: 1280px) {
  thead {
    font-size: 10pt;
  }
}
@media (max-width: 1024px) {
  thead {
    font-size: 8pt;
  }
}
tbody tr.isSelected {
  background-color: #1774ad;
  color: #ffffff;
}
tbody tr.isHighlighted {
  background-color: #d4edda;
  color: #155724;
  font-weight: 500;
  animation: highlightPulse 1.5s ease-in-out;
}
@keyframes highlightPulse {
  0% {
    background-color: #28a745;
    color: #ffffff;
  }
  100% {
    background-color: #d4edda;
    color: #155724;
  }
}
tbody tr.isSelected.isHighlighted {
  background-color: #1774ad;
  color: #ffffff;
}
tbody tr:nth-child(even):not(.isSelected):not(.isHighlighted) {
  background-color: #f8f8f8;
}
tbody tr:nth-child(odd):not(.isSelected):not(.isHighlighted) {
  background-color: #ffffff;
}
th,
td {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-inline-start: 10px;
  padding-inline-end: 10px;
  text-align: left;
  border-bottom: 1px solid #ebebeb;
}
th:first-child,
td:first-child {
  border-left: none;
}
th:last-child,
td:last-child {
  border-right: none;
}
tr {
  border: 1px solid #ebebeb;
  overflow: hidden;
}
tbody tr:last-child td {
  border-bottom: none;
}
tfoot {
  width: 100%;
  background-color: #e0e0e0;
  font-weight: bold;
  color: #444444;
  font-size: 12pt;
}
@media (max-width: 2560px) {
  tfoot {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  tfoot {
    font-size: 12pt;
  }
}
@media (max-width: 1280px) {
  tfoot {
    font-size: 10pt;
  }
}
@media (max-width: 1024px) {
  tfoot {
    font-size: 8pt;
  }
}
.column-actions {
  text-align: right;
  width: 180px;
}
.table-footer-wrapper {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.table-footer-wrapper .table-footer-content.left {
  text-align: left;
  padding-inline-end: 10px;
  align-content: center;
}
.table-footer-wrapper .table-footer-content.center {
  flex: 1;
  text-align: center;
}
.table-footer-wrapper .table-footer-content.right {
  text-align: right;
  align-content: center;
}
.table-footer-wrapper .button-forward {
  padding: 0;
  margin-inline-start: 2px;
  height: 30px;
  width: 30px;
  border-radius: 20px;
  border-color: #1b638b;
  border-width: 1px;
  color: #1b638b;
  font-size: 12pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .button-forward {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .button-forward {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .button-forward {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .button-forward {
    font-size: 8pt;
  }
}
.table-footer-wrapper .button-backward {
  padding: 0;
  margin-inline-end: 2px;
  height: 30px;
  width: 30px;
  border-radius: 20px;
  border-color: #1b638b;
  border-width: 1px;
  color: #1b638b;
  font-size: 12pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .button-backward {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .button-backward {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .button-backward {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .button-backward {
    font-size: 8pt;
  }
}
.table-footer-wrapper .page-index {
  padding: 0;
  border-style: solid;
  border-color: #1b638b;
  border-width: 1px;
  text-align: center;
  height: 30px;
  width: 100px;
  border-radius: 20px;
  font-size: 12pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .page-index {
    font-size: 12pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .page-index {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .page-index {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .page-index {
    font-size: 8pt;
  }
}
.table-footer-wrapper .page-size {
  padding: 0;
  text-align: center;
  height: 30px;
  width: 40px;
  border-radius: 10px;
  border-style: solid;
  border-color: #1b638b;
  font-size: 10pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .page-size {
    font-size: 10pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .page-size {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .page-size {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .page-size {
    font-size: 8pt;
  }
}
.table-footer-wrapper .page-size select {
  font-size: 10pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .page-size select {
    font-size: 10pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .page-size select {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .page-size select {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .page-size select {
    font-size: 8pt;
  }
}
.table-footer-wrapper .page-size:active {
  outline-color: #1b638b;
  outline-offset: -1px;
  outline-width: 1px;
  outline-style: solid;
  font-size: 10pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .page-size:active {
    font-size: 10pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .page-size:active {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .page-size:active {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .page-size:active {
    font-size: 8pt;
  }
}
.table-footer-wrapper .page-size:active select {
  font-size: 10pt;
}
@media (max-width: 2560px) {
  .table-footer-wrapper .page-size:active select {
    font-size: 10pt;
  }
}
@media (max-width: 1920px) {
  .table-footer-wrapper .page-size:active select {
    font-size: 10pt;
  }
}
@media (max-width: 1280px) {
  .table-footer-wrapper .page-size:active select {
    font-size: 8pt;
  }
}
@media (max-width: 1024px) {
  .table-footer-wrapper .page-size:active select {
    font-size: 8pt;
  }
}
.switch-container {
  display: flow;
  align-items: center;
  gap: 10px;
  margin-top: 20px;
  margin-bottom: 20px;
  margin-inline-start: 0px;
  margin-inline-end: 0px;
}
.switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 24px;
}
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
.slider {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  border-radius: 24px;
  transition: background-color 0.4s ease;
}
.slider:before {
  content: "";
  position: absolute;
  height: 18px;
  width: 18px;
  left: 3px;
  top: 3px;
  background-color: white;
  border-radius: 50%;
  transition: transform 0.4s ease;
  z-index: 2;
}
.toggle-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 12px;
  font-weight: bold;
  color: white;
  pointer-events: none;
  z-index: 3;
}
input:checked + .slider {
  background-color: #1b638b;
}
input:checked + .slider:before {
  transform: translateX(36px);
}
input:not(:checked) + .slider .toggle-text {
  transform: translate(calc(-50% + 4px), -50%);
}
input:checked + .slider .toggle-text {
  transform: translate(calc(-50% - 10px), -50%);
}
.grid-button {
  margin-left: 5px;
}
.grid-button.add {
  color: #2d865a;
  border-color: #2d865a;
}
.grid-button.add:hover {
  border-color: rgb(32.1787709497, 95.8212290503, 64.3575418994);
  background-color: rgba(57.8212290503, 172.1787709497, 114.3575418994, 0.4941176471);
  color: rgb(32.1787709497, 95.8212290503, 64.3575418994);
}
.grid-button.edit {
  color: #f7914d;
  border-color: #f7914d;
}
.grid-button.edit:hover {
  border-color: rgb(244.8064516129, 114.8387096774, 28.1935483871);
  background-color: rgba(249.1935483871, 175.1612903226, 125.8064516129, 0.368627451);
  color: rgb(244.8064516129, 114.8387096774, 28.1935483871);
}
.grid-button.delete {
  color: #f7706a;
  border-color: #f7706a;
}
.grid-button.delete:hover {
  border-color: rgb(244.4012738854, 65.5477707006, 57.5987261146);
  background-color: rgba(249.5987261146, 159.127388535, 154.4012738854, 0.3490196078);
  color: rgb(244.4012738854, 65.5477707006, 57.5987261146);
}
/*# sourceMappingURL=pageable-table.component-WKOB3C2W.css.map */
